import { Typography } from "@mui/material";
import React from "react";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";

export function ImageResolutionHint({ res }: { res: string }) {
  const fontSize = "0.9rem";
  return (
    <Typography color={"textSecondary"} style={{ fontSize }}>
      <TranslationWrapper tDefault={"Preferred resolution: "} tKey={"image.hints.preferred-resolution"} />
      <Typography display={"inline"} style={{ fontSize }}>
        {res}
      </Typography>
    </Typography>
  );
}
